import React, { useState, useEffect } from "react";
import AffiliateLayout from "./layout";
import {
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col,
  Button,
} from "reactstrap";
import classnames from "classnames";
import axios from "axios";
import { END_POINT } from "../../constants/defaultValues";

const MarketingKit = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [copied, setCopied] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({ banners: [], contents: [], videos: [] });

  useEffect(() => {
    fetchMarketingKit();
  }, []);

  const fetchMarketingKit = async () => {
    try {
      const token = localStorage.getItem("affiliate_token");
      const res = await axios.get(`${END_POINT}/api/affiliate/marketing-kit`, {
        headers: { "x-auth-token": token },
      });
      if (res.status === 200) {
        setData(res.data);
      }
    } catch (error) {
      console.error("Error fetching marketing kit:", error);
    } finally {
      setLoading(false);
    }
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const copyToClipboard = (text, id) => {
    navigator.clipboard.writeText(text);
    setCopied(id);
    setTimeout(() => setCopied(null), 2000);
  };

  if (loading) {
    return (
      <AffiliateLayout title="Marketing Kit">
        <div className="loading-state">
          <div className="simple-spinner"></div>
        </div>
      </AffiliateLayout>
    );
  }

  return (
    <AffiliateLayout title="Marketing Kit">
      <div className="aff-page-container">
        <div className="page-header">
          <h2>Marketing Kit</h2>
          <p>
            Tài nguyên hình ảnh, nội dung mẫu giúp bạn tiếp thị hiệu quả hơn.
          </p>
        </div>

        <div className="aff-page-content">
          <Nav tabs className="mb-4">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => toggle("1")}
                style={{ cursor: "pointer" }}
              >
                Hình ảnh & Banner
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => toggle("2")}
                style={{ cursor: "pointer" }}
              >
                Nội dung mẫu
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "3" })}
                onClick={() => toggle("3")}
                style={{ cursor: "pointer" }}
              >
                Video giới thiệu
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            {/* Banners Tab */}
            <TabPane tabId="1">
              <Row>
                {data.banners.length > 0 ? (
                  data.banners.map((banner) => (
                    <Col md="6" lg="4" key={banner.id} className="mb-4">
                      <Card className="h-100 shadow-sm border-0">
                        <div
                          style={{
                            height: "200px",
                            backgroundImage: `url(${banner.url})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            borderTopLeftRadius: "0.25rem",
                            borderTopRightRadius: "0.25rem",
                          }}
                        />
                        <CardBody>
                          <h5 className="font-weight-bold">{banner.title}</h5>
                          <p className="text-muted small mb-3">
                            Kích thước: {banner.size}
                          </p>
                          <Button
                            color="primary"
                            outline
                            block
                            onClick={() => window.open(banner.url, "_blank")}
                          >
                            <i className="simple-icon-cloud-download mr-1"></i>{" "}
                            Tải về
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                  ))
                ) : (
                  <Col md="12" className="text-center py-5">
                    <i className="simple-icon-picture display-4 text-muted mb-3"></i>
                    <h3>Chưa có banner</h3>
                    <p className="text-muted">
                      Các banner marketing sẽ sớm được bổ sung.
                    </p>
                  </Col>
                )}
              </Row>
            </TabPane>

            {/* Content Tab */}
            <TabPane tabId="2">
              <Row>
                {data.contents.length > 0 ? (
                  data.contents.map((content) => (
                    <Col md="12" key={content.id} className="mb-4">
                      <Card className="shadow-sm border-0">
                        <CardBody>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="font-weight-bold mb-0">
                              {content.title}
                            </h5>
                            <Button
                              color={
                                copied === content.id ? "success" : "secondary"
                              }
                              size="sm"
                              onClick={() =>
                                copyToClipboard(content.text, content.id)
                              }
                            >
                              {copied === content.id
                                ? "Đã sao chép!"
                                : "Sao chép"}
                            </Button>
                          </div>
                          <div className="p-3 bg-light border">
                            <pre
                              style={{
                                whiteSpace: "pre-wrap",
                                fontFamily: "inherit",
                                margin: 0,
                              }}
                            >
                              {content.text}
                            </pre>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))
                ) : (
                  <Col md="12" className="text-center py-5">
                    <i className="simple-icon-doc display-4 text-muted mb-3"></i>
                    <h3>Chưa có nội dung mẫu</h3>
                    <p className="text-muted">
                      Các nội dung marketing mẫu sẽ sớm được bổ sung.
                    </p>
                  </Col>
                )}
              </Row>
            </TabPane>

            {/* Video Tab */}
            <TabPane tabId="3">
              <Row>
                {data.videos.length > 0 ? (
                  data.videos.map((video) => (
                    <Col md="6" lg="4" key={video.id} className="mb-4">
                      <Card className="shadow-sm border-0">
                        <CardBody>
                          <h5 className="font-weight-bold">{video.title}</h5>
                          <a
                            href={video.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-outline-primary btn-block"
                          >
                            <i className="simple-icon-control-play mr-1"></i>{" "}
                            Xem Video
                          </a>
                        </CardBody>
                      </Card>
                    </Col>
                  ))
                ) : (
                  <Col md="12" className="text-center py-5">
                    <i className="simple-icon-camrecorder display-4 text-muted mb-3"></i>
                    <h3>Đang cập nhật video...</h3>
                    <p className="text-muted">
                      Các video giới thiệu sẽ sớm được bổ sung.
                    </p>
                  </Col>
                )}
              </Row>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </AffiliateLayout>
  );
};

export default MarketingKit;
